"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnimplementedExpression = exports.Expression = void 0;
var util_1 = require("../util/util");
var builder_1 = require("./builder");
var Expression = /** @class */ (function () {
    function Expression(json) {
        if (json.operand != null) {
            var op = (0, builder_1.build)(json.operand);
            if ((0, util_1.typeIsArray)(json.operand)) {
                this.args = op;
            }
            else {
                this.arg = op;
            }
        }
        if (json.localId != null) {
            this.localId = json.localId;
        }
    }
    Expression.prototype.execute = function (ctx) {
        if (this.localId != null) {
            // Store the localId and result on the root context of this library
            var execValue = this.exec(ctx);
            ctx.rootContext().setLocalIdWithResult(this.localId, execValue);
            return execValue;
        }
        else {
            return this.exec(ctx);
        }
    };
    Expression.prototype.exec = function (_ctx) {
        return this;
    };
    Expression.prototype.execArgs = function (ctx) {
        if (this.args != null) {
            return this.args.map(function (arg) { return arg.execute(ctx); });
        }
        else if (this.arg != null) {
            return this.arg.execute(ctx);
        }
        else {
            return null;
        }
    };
    return Expression;
}());
exports.Expression = Expression;
var UnimplementedExpression = /** @class */ (function (_super) {
    __extends(UnimplementedExpression, _super);
    function UnimplementedExpression(json) {
        var _this = _super.call(this, json) || this;
        _this.json = json;
        return _this;
    }
    UnimplementedExpression.prototype.exec = function (_ctx) {
        throw new Error("Unimplemented Expression: ".concat(this.json.type));
    };
    return UnimplementedExpression;
}(Expression));
exports.UnimplementedExpression = UnimplementedExpression;
//# sourceMappingURL=expression.js.map